
export const locale = {
  'ATTACHMENT' : {
    'DROP_LABEL' : 'Drop documents to attach or click to select',
    'DROP_LABEL_DISABLED' : 'No attached files',
  }
};
